<template>
  <div class="Image-box">
    <ul>
      <li @click="$router.push({path: '/imagingTechnique/4000'})">
        <img src="../../assets/home/大师精讲堂@2x.png" alt="">
      </li>
      <li @click="$router.push({path: '/imagingNurse/4100'})">
        <img src="../../assets/home/影像技术和护理@2x.png" alt="">
      </li>
      <li @click="$router.push({path: '/internationalVoice/4200'})">
        <img src="../../assets/home/国际之声@2x.png" alt="">
      </li>
      <li @click="$router.push({path: '/star/4300'})">
        <img src="../../assets/home/STAR@2x.png" alt="">
      </li>
    </ul>
    <footer-number/>
  </div>
</template>

<script>
import {wxShare} from "@/common/js/wx";
import ds from '../../assets/home/影像技术@2x.png'
import FooterNumber from "@/components/footer/footerNumber";
export default {
  name: "imageCollection",
  components: {FooterNumber},
  mounted() {
    wxShare('大师精讲堂', '', ds)
  }
}
</script>

<style lang="scss" scoped>
.Image-box {
  background: #FFFFFF;
  ul {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 40px 24px;
    li {
      width: 700px;
      height: 252px;
      margin-bottom: 40px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
